import {checkValid} from "../../../globalModels/functions/ModelsValidate";
import {DELIVERY_DESTINATIONS} from "@/staticData/staticVariables";
import {Files} from "@/components/globalModels/Files";


export function ShippingCompanyForOrder() {

  this.checkValid = checkValid

  this.data = {
    id: '',
    name: '',
    shippingCompany: '',
    forUSA: '',

    Files: new Files({
      maxCountFiles: 1,
      maxSizeFiles: 3
    }),
  }

  this.validation = {
    shippingCompany: false,
    name: false,
  }

  this.validationTranslate = {
    shippingCompany: '',
    name: '',
  }

  this.validationTxt = {
    shippingCompany: false,
    name: false,
  }

  /**
   * Getters
   */
  this.getId = () => {
    return this.data.id
  }
  this.getName = () => {
    return this.data.name
  }
  this.getForUSA = () => {
    return this.data.forUSA
  }
  this.getShippingCompany = () => {
    return this.data.shippingCompany
  }

  /**
   * Setters
   */
  this.setId = (val) => {
    this.data.id = val
  }
  this.setName = (val) => {
    this.data.name = val
  }
  this.setForUSA = (val) => {
    this.data.forUSA = val
  }
  this.setShippingCompany = (val) => {
    this.data.shippingCompany = val
  }

}


/**
 * Global Setters
 */

ShippingCompanyForOrder.prototype.setItem = function (val) {

  this.setShippingCompany(val.delivery_service)
  this.setName(val.name)
  this.setId(val.id)
  this.setForUSA(val.delivery_destinatons.id === DELIVERY_DESTINATIONS.FOR_USA.id)

  if (val['logo_base64'])
    this.setShippingCompanyDownloadFiles(val['logo_base64'])
}

ShippingCompanyForOrder.prototype.setShippingCompanyDownloadFiles = function (val) {
  this.data.Files.pushDownloadFiles(val)
}
/**
 * Functions
 */


/**
 * Validations
 */

ShippingCompanyForOrder.prototype.firstValidation = function () {

  let data = this.data

  let validationItems = {
    name: data.name,
    shippingCompany: data.shippingCompany?.id,
  }

  let validationOptions = {
    name: {type: ['empty']},
    shippingCompany: {type: ['empty']},
  }


  return this.checkValid(validationItems, validationOptions)
}


/**
 * Prepare Data
 */

ShippingCompanyForOrder.prototype.prepareSave = function () {

  let data = {
    "name": this.getName(),
    "delivery_service_id": this.getShippingCompany()?.id,
    "delivery_destination_id": this.getForUSA() ? DELIVERY_DESTINATIONS.FOR_USA.id : DELIVERY_DESTINATIONS.FOR_NOT_USA.id,
  }

  if(this.data.Files.getFiles().length > 0 ){
    data['logo_base64'] = `data:${this.data.Files.getFiles()[0].item[0].type};base64,` + this.data.Files.getFiles()[0].base64String
    data['svg_logo'] = this.data.Files.getFiles()[0].binaryData
  }

  return data
}
